/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetAllBalancesParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useAllBalances(
	params: GetAllBalancesParams,
	options?: UseMgoClientQueryOptions<'getAllBalances'>,
) {
	return useMgoClientQuery(
		{
			method: 'getAllBalances',
			params,
		},
		options,
	);
}
